import { Fragment, useContext } from 'react';
import { Outlet, Link } from 'react-router-dom';

import CartIcon from '../../components/cart-icon/cart-icon.component';
import CartDropdown from '../../components/cart-dropdown/cart-dropdown.component';

import logo from '../../assets/logo.png';
import { UserContext } from '../../contexts/user.context';
import { CartContext } from '../../contexts/cart.context';

import { signOutUser } from '../../utils/firebase/firebase.utils';

import './navigation.styles.scss';

const Navigation = () => {
  const { currentUser } = useContext(UserContext);
  const {isCartOpen} = useContext(CartContext);

  return (
    <Fragment>
      <div className='navigation'>
        <Link className='logo-container' to='/'>
          <div>
            <img className='logo' src={logo} alt='logo' />
          </div>
        </Link>
        <div className='nav-links-container'>
          <Link className='nav-link' to='shop'>
            МАГАЗИН
          </Link>
          {currentUser ? (
            <span className='nav-link' onClick={signOutUser}>
              ВИЙТИ
            </span>
          ) : (
            <Link className='nav-link' to='auth'>
              УВІЙТИ
            </Link>
          )}
          <CartIcon />
        </div>
        {isCartOpen && <CartDropdown />}
      </div>
      <Outlet />
    </Fragment>
  );
};

export default Navigation;
